/**
 * Product Grid Variant Selector (KŪN)
 * Size/color on cards, AJAX ATC, colourway image swap without breaking Pipeline media.
 */
(function() {
  document.addEventListener('DOMContentLoaded', initGridVariantSelectors);
  document.addEventListener('shopify:section:load', initGridVariantSelectors);

  function initGridVariantSelectors() {
    var cards = document.querySelectorAll('[data-product-grid-form]');
    cards.forEach(initCard);
  }

  function initCard(card) {
    if (card.dataset.variantSelectorInit) return;
    card.dataset.variantSelectorInit = 'true';

    var variantsEl = card.querySelector('[data-product-variants]');
    if (!variantsEl) return;

    var productData = JSON.parse(variantsEl.textContent);
    var variants = productData.variants;
    var optionNames = productData.options;
    var options = card.querySelectorAll('[data-option-name]');
    var hiddenInput = card.querySelector('[data-variant-id]');
    if (!hiddenInput || options.length === 0) return;

    var selectedOptions = {};

    optionNames.forEach(function(name) {
      var firstBtn = card.querySelector('[data-option-name="' + name + '"]');
      if (firstBtn) {
        selectedOptions[name] = firstBtn.getAttribute('data-option-value');
        markActive(card, name, selectedOptions[name]);
      }
    });

    updateVariant(variants, selectedOptions, optionNames, hiddenInput, card, null);

    options.forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var name = btn.getAttribute('data-option-name');
        var value = btn.getAttribute('data-option-value');
        selectedOptions[name] = value;
        markActive(card, name, value);
        updateVariant(variants, selectedOptions, optionNames, hiddenInput, card, btn);
      });
    });

    var addBtn = card.querySelector('.product__grid__add-btn');
    var form = card.querySelector('.product__grid__add-form');
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        e.stopPropagation();

        var variantId = hiddenInput.value;
        if (!variantId || !addBtn || addBtn.disabled) return;

        var originalText = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.textContent = '...';

        var cartUrl = (window.theme && window.theme.routes && window.theme.routes.cart)
          ? window.theme.routes.cart + '/add.js'
          : '/cart/add.js';

        var payload = 'id=' + encodeURIComponent(variantId) + '&quantity=1';

        fetch(cartUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: payload
        })
        .then(function(response) {
          if (response.ok) return response.json();
          return response.json().then(function(err) { throw err; });
        })
        .then(function() {
          addBtn.textContent = '✓';
          addBtn.disabled = false;
          setTimeout(function() { addBtn.textContent = originalText; }, 1500);

          var cartJsUrl = (window.theme && window.theme.routes && window.theme.routes.cart)
            ? window.theme.routes.cart + '.js'
            : '/cart.js';

          fetch(cartJsUrl, { credentials: 'same-origin' })
            .then(function(r) { return r.json(); })
            .then(function(cart) {
              document.dispatchEvent(new CustomEvent('theme:cart:change', {
                bubbles: true,
                detail: { cart: cart }
              }));
            })
            .catch(function() {});
        })
        .catch(function() {
          addBtn.textContent = 'Error';
          setTimeout(function() {
            addBtn.textContent = originalText;
            addBtn.disabled = false;
          }, 1500);
        });
      });
    }
  }

  function markActive(card, name, activeValue) {
    card.querySelectorAll('[data-option-name="' + name + '"]').forEach(function(btn) {
      var val = btn.getAttribute('data-option-value');
      if (btn.classList.contains('product__grid__size-chip')) {
        if (val === activeValue) {
          btn.style.borderColor = '#222';
          btn.style.background = '#222';
          btn.style.color = '#fff';
        } else {
          btn.style.borderColor = '#ccc';
          btn.style.background = 'transparent';
          btn.style.color = 'inherit';
        }
      } else if (btn.classList.contains('product__grid__color-swatch')) {
        if (val === activeValue) {
          btn.style.borderColor = '#222';
          btn.style.boxShadow = '0 0 0 1px #222';
        } else {
          btn.style.borderColor = '#ddd';
          btn.style.boxShadow = 'none';
        }
      }
    });
  }

  function expandTemplatesOnce(panel) {
    if (!panel || panel.dataset.kunMediaReady === '1') return;
    panel.querySelectorAll('template').forEach(function(tpl) {
      try {
        var parent = tpl.parentNode;
        if (!parent) return;
        parent.insertBefore(tpl.content.cloneNode(true), tpl);
        tpl.remove();
      } catch (e) {}
    });
    panel.querySelectorAll('product-grid-item-image').forEach(function(el) {
      el.setAttribute('loading', 'eager');
    });
    panel.dataset.kunMediaReady = '1';
  }

  function swapCardImage(card, match, clickedBtn) {
    var pgi = card.closest('product-grid-item');
    if (!pgi) return;

    var panelId = null;
    if (clickedBtn && clickedBtn.classList.contains('product__grid__color-swatch')) {
      panelId = clickedBtn.getAttribute('data-grid-item-variant');
    }
    if (!panelId && match) {
      card.querySelectorAll('.product__grid__color-swatch[data-grid-item-variant]').forEach(function(sw) {
        var val = sw.getAttribute('data-option-value');
        if (match.options && match.options.indexOf(val) !== -1) {
          panelId = sw.getAttribute('data-grid-item-variant');
        }
      });
    }

    var activePanel = null;
    if (panelId) {
      pgi.querySelectorAll('product-grid-item-variant[data-grid-item-variant]').forEach(function(panel) {
        if (panel.getAttribute('data-grid-item-variant') === String(panelId)) {
          panel.removeAttribute('hidden');
          activePanel = panel;
        } else {
          panel.setAttribute('hidden', '');
        }
      });
    }
    if (!activePanel) {
      activePanel = pgi.querySelector('product-grid-item-variant:not([hidden])');
    }
    expandTemplatesOnce(activePanel);

    // Prefer colourway URL from swatch / variant — apply ONLY to the current slide img
    var imageUrl = (clickedBtn && clickedBtn.getAttribute('data-swatch-image')) || (match && match.featured_image) || null;
    if (!imageUrl || !activePanel) return;

    var current = activePanel.querySelector('[data-grid-current-image] img, product-grid-item-image[data-grid-current-image] img, img');
    if (current) {
      current.setAttribute('src', imageUrl);
      current.removeAttribute('srcset');
      current.setAttribute('loading', 'eager');
    }
  }

  function colorKeyName(optionNames) {
    for (var i = 0; i < optionNames.length; i++) {
      var n = (optionNames[i] || '').toLowerCase();
      if (n === 'color' || n === 'colour') return optionNames[i];
    }
    return null;
  }

  function syncStockUI(card, match, variants, selectedOptions, optionNames) {
    var form = card.querySelector('.product__grid__add-form');
    var addBtn = card.querySelector('.product__grid__add-btn');
    var row = card.querySelector('.product__grid__price-cart-row');
    var qtyEl = card.querySelector('.product__grid__qty');
    // strip leftover stock labels
    card.querySelectorAll('.product__grid__qty').forEach(function(el){ el.remove(); });
    qtyEl = null;

    var colorName = colorKeyName(optionNames);
    var colourQty = 0;
    if (colorName && selectedOptions[colorName]) {
      var idx = optionNames.indexOf(colorName);
      variants.forEach(function(v) {
        if (idx >= 0 && v.options[idx] === selectedOptions[colorName]) {
          colourQty += (v.inventory_quantity || 0);
        }
      });
    }

    var available = !!(match && match.available);

    // Always wipe sold-out labels first (prevents duplicates)
    card.querySelectorAll('.product__grid__sold-out').forEach(function(el) {
      el.remove();
    });

    if (available) {
      if (form) form.style.display = '';
      if (addBtn) {
        addBtn.disabled = false;
        addBtn.style.opacity = '1';
        if (addBtn.dataset.kunOrigText) addBtn.textContent = addBtn.dataset.kunOrigText;
      }
      // Naji 2026-09-21: never show stock counts on storefront
      if (qtyEl) {
        qtyEl.remove();
      }
    } else {
      if (qtyEl) qtyEl.style.display = 'none';
      if (form) form.style.display = 'none';
      if (addBtn) {
        if (!addBtn.dataset.kunOrigText) addBtn.dataset.kunOrigText = addBtn.textContent;
        addBtn.disabled = true;
        addBtn.style.opacity = '0.5';
      }
      if (row) {
        var soldEl = document.createElement('span');
        soldEl.className = 'product__grid__sold-out';
        soldEl.style.cssText = 'font-size: 11px; text-transform: uppercase; color: #999;';
        soldEl.textContent = 'Sold out';
        row.appendChild(soldEl);
      }
    }
  }

  function updateVariant(variants, selectedOptions, optionNames, hiddenInput, card, clickedBtn) {
    var selectedArray = optionNames.map(function(name) {
      return selectedOptions[name];
    });

    var match = null;
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var isMatch = true;
      for (var j = 0; j < selectedArray.length; j++) {
        if (v.options[j] !== selectedArray[j]) {
          isMatch = false;
          break;
        }
      }
      if (isMatch) {
        match = v;
        break;
      }
    }

    // Colour-only fallback for image when exact size combo missing
    if (!match) {
      var cname = colorKeyName(optionNames);
      if (cname) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var idx = optionNames.indexOf(cname);
          if (idx >= 0 && v.options[idx] === selectedOptions[cname]) {
            match = v;
            break;
          }
        }
      }
    }

    if (match) {
      hiddenInput.value = match.id;
      syncStockUI(card, match, variants, selectedOptions, optionNames);
      // Image swap on colour clicks (or init)
      if (!clickedBtn || clickedBtn.classList.contains('product__grid__color-swatch') || !card.dataset.kunImageInit) {
        swapCardImage(card, match, clickedBtn);
        card.dataset.kunImageInit = '1';
      }
    }
  }

  function kunStripStockCounts() {
    document.querySelectorAll('.product__grid__qty').forEach(function(el){ el.remove(); });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', kunStripStockCounts);
  } else {
    kunStripStockCounts();
  }
  setTimeout(kunStripStockCounts, 500);
  setTimeout(kunStripStockCounts, 1500);

})();
